import { createStyles, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { layoutContentMaxWidthPx } from '../../../../shared/style-settings'

export const useMainPageLatestItemsSectionStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        backgroundColor: theme.palette.common.white,
        paddingTop: theme.spacing(10),
        paddingBottom: theme.spacing(10),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        borderTop: `1px solid ${theme.palette.grey[200]}`,
        [theme.breakpoints.down('sm')]: {
          paddingTop: theme.spacing(8),
          paddingBottom: theme.spacing(8),
          paddingLeft: theme.spacing(2.5),
          paddingRight: theme.spacing(2.5),
        },
      },
      inner: {
        maxWidth: layoutContentMaxWidthPx,
        margin: '0 auto',
      },
      loadingBox: {
        display: 'flex',
        justifyContent: 'center',
        padding: theme.spacing(6, 0),
      },
      muted: {
        margin: 0,
        fontSize: '0.9375rem',
        color: theme.palette.text.secondary,
        fontWeight: 500,
      },
      error: {
        margin: 0,
        fontSize: '0.9375rem',
        color: theme.palette.error.main,
        fontWeight: 500,
      },
    })
)
